import axiosInstance from '@/utils/api.js'

var state = {
  IPTVservice: [],
  mediaGroups: [],
  mediaContents: []
}

var getters = {
  IPTV_SERVICE: (state) => {
    return state.IPTVservice
  },
  MEDIA_GROUPS: (state) => {
    return state.mediaGroups
  },
  MEDIA_CONTENTS: (state) => {
    return state.mediaContents
  }
}

var mutations = {
  SET_IPTV_SERVICE: (state, payload) => {
    state.IPTVservice = payload || []
  },
  SET_MEDIA_GROUPS: (state, payload) => {
    state.mediaGroups = payload
  },
  SET_MEDIA_CONTENTS: (state, payload) => {
    state.mediaContents = payload
  }
}

var actions = {
  GET_IPTV_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/iptv?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_IPTV_SERVICE', result.data)
    }
  },
  CREATE_IPTV_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/iptv', payload)
  },
  UPDATE_IPTV_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/iptv', payload)
  },
  GET_MEDIA_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/media_groups')
    if (result.status === 200) {
      context.commit('SET_MEDIA_GROUPS', result.data)
    }
  },
  GET_MEDIA_CONTENTS: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/media_contents')
    if (result.status === 200) {
      context.commit('SET_MEDIA_CONTENTS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/IPTVservices.js